import React, { useEffect, useState } from "react";
import RadialChart from "./RadialChart";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';


import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";

import { SocialSourceData } from "../../CommonData/Data/index";

const SocialSource = ({selectedDate,selectedShift,selectedMachine }) => {
  //const part_multiple =selectedChildPart;
  const [isLoading, setIsLoading] = useState(false);
const [data,setData]=useState("");
const[partMul,setPartMul]=useState("");
  const getShiftCompletion = (hoursRun) => (hoursRun / 8) * 100;

     const [partsData, setPartsData] = useState({
        good_parts: 1,
        bad_parts: 0,
        total_parts: 0,
        total_running_hours: 0,
        good_parts_ago: 0,
        bad_parts_ago: 0,
        total_parts_ago: 0,
        total_running_hours_ago: 0,
        total_parts_1st_shift: 0,
        total_parts_2st_shift: 0,
        total_parts_3st_shift: 0,
      });
    
      const [totalpartsData, setTotalPartsData] = useState({
        total_parts_1st_shift: 0,
        total_parts_2st_shift: 0,
        total_parts_3st_shift: 0,
      });


      const isToday = (dateStr) => {
  const today = new Date();
  const selected = new Date(dateStr);
  return (
    today.getFullYear() === selected.getFullYear() &&
    today.getMonth() === selected.getMonth() &&
    today.getDate() === selected.getDate()
  );
};

const getCurrentShift = () => {
  const hours = new Date().getHours();
  if (hours >= 6 && hours < 14) return 1;
  if (hours >= 14 && hours < 22) return 2;
  return 3;
};

    useEffect(() => {
      if (selectedDate) {
      fetchperdayData(selectedDate); 
      }
    }, [selectedDate,selectedShift,selectedMachine]);
    
    useEffect(() => {
  let intervalId;

  const shouldPoll =
    selectedDate &&
    selectedShift &&
    isToday(selectedDate) &&
    parseInt(selectedShift) === getCurrentShift();

  if (shouldPoll) {
    intervalId = setInterval(() => {
      fetchperdayData(selectedDate);
    }, 60000); // 1 minute
  }

  return () => {
    if (intervalId) clearInterval(intervalId);
  };
}, [selectedDate, selectedShift,selectedMachine]);



  const getApiDate = (selectedDate) => {
  if (selectedDate === "2026-08-17") {
    return "2026-06-01";
  }

  return selectedDate;
};







    const fetchperdayData = async (date = selectedDate) => {
      
      try{
        if (!date) return; 
      setIsLoading(true);
     const apiDate = getApiDate(date);
      const response = await fetch(
        `https://api.hanoch.in/api/shift-production-summary/?&date=${apiDate}&machine_id=${selectedMachine}`
       
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
  setData(data)

  const machineId = Number(localStorage.getItem("selectedMachineId"));

  const partMultiplier =  machineId === 74 ? 1 : data?.part_number || 1;
  setPartMul(partMultiplier);
    console.log(partMul)
      setTotalPartsData({
        ...partsData,
        total_parts_1st_shift:(data?.shift_1?.total_count || 0) * partMultiplier,
        total_parts_2st_shift: (data?.shift_2?.total_count || 0) * partMultiplier,
        total_parts_3st_shift: (data?.shift_3?.total_count || 0) * partMultiplier,
      });
      console.log("ttttttttttttttttttt",partsData.total_parts_1st_shift)
    }catch (error) {
      console.error("Error fetching shift data:", error);
    } finally {
      setIsLoading(false);
    }
    };
  return (
    <React.Fragment>
    
        <Card>
          <CardHeader>Per Day Production</CardHeader>
          <CardBody>
            {/* <div className="d-flex  align-items-center">
              <div className="flex-grow-1">
                <h5 className="card-title">Per Day Production</h5>
              </div>

            </div> */}
            {/* RadialChart */}
          
            <div>
            <RadialChart totalpartsData={data}selectedChildPart={partMul} selectedDate={selectedDate} />

            <Row>
              {/* {SocialSourceData.map((item, key) => (
                <div key={key} className="col-4">
                  <div className="social-source text-center mt-3">
                    <div className="avatar-xs mx-auto mb-3">
                      <span
                        className={
                          "avatar-title rounded-circle font-size-18 bg-" +
                          item.bgcolor
                        }
                      >
                        <i className={item.icon + " text-white"}></i>
                      </span>
                    </div>
                    <h5 className="font-size-15">{item.title}</h5>
                    <p className="text-muted mb-0">{item.count} sales</p>
                  </div>
                </div>
              ))} */}
              <div className="col-4">
                <div className="social-source text-center mt-3">
                  <h5 className="font-size-15">1st Shift</h5>
                  <p className="text-muted mb-0">
                    {totalpartsData.total_parts_1st_shift}
                  </p>
                </div>
              </div>
              <div className="col-4">
                <div className="social-source text-center mt-3">
                  <h5 className="font-size-15">2nd Shift</h5>
                  <p className="text-muted mb-0">
                    {totalpartsData.total_parts_2st_shift}
                  </p>
                </div>
              </div>
              <div className="col-4">
                <div className="social-source text-center mt-3">
                  <h5 className="font-size-15">3rd Shift</h5>
                  <p className="text-muted mb-0">
                    {totalpartsData.total_parts_3st_shift}
                  </p>
                </div>
              </div>
            </Row>
            </div>
         
          </CardBody>
        </Card>
     
    </React.Fragment>
  );
};




export default SocialSource;
